module.exports = __webpack_public_path__ + "static/img/img-sreen03.8347abe.jpg";